import { render, staticRenderFns } from "./GroupTransaction.vue?vue&type=template&id=63104666"
import script from "./GroupTransaction.vue?vue&type=script&lang=js"
export * from "./GroupTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports